import { mapGetters } from 'vuex';
import mvtCollapsibleLinks from '@/common/components/mvtcollapsiblelinks/mvt-collapsiblelinks.vue';
import mvtDropdownList from '@/common/components/mvtdropdownlist/mvt-dropdownlist.vue';
import schoolsTable from '../schoolstable/schools-table.vue';
import { parseQueryString } from '@/common/utilities/nojq/_utilities.js';

const schoolType = { public: '1', private: '2', charter: '3' };
export default {
    name: 'schoolsCity',
    inject: ['$eventBus'],
    props: {
        data: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            sortValue: '',
        };
    },
    components: {
        mvtCollapsibleLinks,
        mvtDropdownList,
        schoolsTable,
    },
    computed: {
        ...mapGetters('glb', ['viewport', 'glb']),
        filterData() {
            return [
                {
                    text: 'All',
                    href: `${this.glb.appUrl}${this.data.cityInfo.sitemapCitySchoolPageUrl}`,
                    value: 'all',
                },
                {
                    text: 'Public',
                    href: `${this.glb.appUrl}${this.data.cityInfo.sitemapCitySchoolPageUrl}?sort=${schoolType.public}`,
                    value: 'public',
                },
                {
                    text: 'Private',
                    href: `${this.glb.appUrl}${this.data.cityInfo.sitemapCitySchoolPageUrl}?sort=${schoolType.private}`,
                    value: 'private',
                },
                {
                    text: 'Charter',
                    href: `${this.glb.appUrl}${this.data.cityInfo.sitemapCitySchoolPageUrl}?sort=${schoolType.charter}`,
                    value: 'charter',
                },
            ];
        },
        sortBy: {
            set(val) {
                this.sortValue = val;
            },
            get() {
                return this.sortValue;
            },
        },
    },
    methods: {
        formatDataList(list) {
            return (
                list &&
                list.map((item) => {
                    return {
                        url: `${this.glb.appUrl}${item.nameForUrl}`,
                        text: item.displayName,
                    };
                })
            );
        },
    },
    mounted() {
        const queryObj = parseQueryString();
        if (queryObj && queryObj.sort) {
            this.sortValue = Object.keys(schoolType).find((key) => schoolType[key] === queryObj.sort);
        }
    },
};
